import React, {useState} from 'react';
import DropTarget from '../DragDrop/DropTarget';
import './Answer.css';
import Text from '../Text/Text';

const Answer = (props)=>{ 
    const [className, setClassName] = useState('answer'); //Вид поля ответа
    const [hiddedWord, setHiddedWord] = useState(true); //При правильном ответе появление слова
     
    let dropped = (e)=> {
        e.containerElem.style.visibility = 'hidden';
        setClassName('answer answerWord');
        setHiddedWord(false);
        props.onDrop('answer');
    };

    return (
            <DropTarget onHit = {dropped} targetKey = {props.targetKey}> 
            <div className = {className} style = {{width: props.widthWord}}> 
                <Text  value = {props.value} hidden = {hiddedWord} />
            </div>
        </DropTarget>
    );        
};
export default Answer;